import { DesktopOnly } from "../../DesktopOnly";
import { MobileOnly } from "../../MobileOnly";
import { ImageViewer, ViewerImageInput } from "./ImageViewer";
import styles from "./fullscreen-image-popup.module.css";

interface FullscreenImagePopupProps {
  images: ViewerImageInput[];
  isOpen: boolean;
  onClose: () => void;
  slideIndex?: number;
}

export const FullscreenImagePopup = ({
  images,
  isOpen,
  onClose,
  slideIndex,
}: FullscreenImagePopupProps) => (
  <>
    <DesktopOnly>
      <ImageViewer
        images={images}
        isOpen={isOpen}
        onClose={onClose}
        slideIndex={slideIndex}
        carouselId="desktopImageViewer"
      />
    </DesktopOnly>

    <MobileOnly>
      <div className={styles["mobileViewerWrapper"]}>
        <ImageViewer
          images={images}
          isOpen={isOpen}
          onClose={onClose}
          slideIndex={slideIndex}
          carouselId="mobileImageViewer"
          renderWrapper={(imageElement, key) => (
            <div key={key} className={styles["mobileImageContainer"]}>
              {imageElement}
            </div>
          )}
        />
      </div>
    </MobileOnly>
  </>
);
